var _line, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitCaseBoxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 61,
    viewBox: "0 0 88 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.395,
    y1: 60.605,
    x2: 72.605,
    y2: 60.605,
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 35,
    r: 11,
    fill: "#F8B400",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5608 48.8493V52.0114C77.5608 54.262 75.7362 56.0848 73.4874 56.0848H15.2331C12.9825 56.0848 11.1597 54.2602 11.1597 52.0114V16.7453C11.1597 14.4947 12.9843 12.6719 15.2331 12.6719H73.4856C75.7362 12.6719 77.559 14.4965 77.559 16.7453V21.7086",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9424 10.4052V3.87438C30.9424 2.3374 32.1881 1.08984 33.7269 1.08984H54.9948C56.5318 1.08984 57.7793 2.33561 57.7793 3.87438V10.4052",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3049 37.9698H42.4148C40.9983 37.9698 39.8496 36.8211 39.8496 35.4045V31.5144C39.8496 30.0979 40.9983 28.9492 42.4148 28.9492H46.3049C47.7215 28.9492 48.8702 30.0979 48.8702 31.5144V35.4045C48.8684 36.8211 47.7215 37.9698 46.3049 37.9698Z",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8496 33.46H11.4092",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4544 33.46H48.8848",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9379 47.4813C81.551 47.4813 86.912 42.1204 86.912 35.5073C86.912 28.8942 81.551 23.5332 74.9379 23.5332C68.3248 23.5332 62.9639 28.8942 62.9639 35.5073C62.9639 42.1204 68.3248 47.4813 74.9379 47.4813Z",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4941 28.9512L68.3804 42.0649",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4941 42.0649L68.3804 28.9512",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4952 6.3916V8.78426",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5201 9.79785H80.5229",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6056 9.79785H76.6084",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4952 10.958V13.3507",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97498 49.2715V51.6659",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00075 52.6777H7.00537",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08714 52.6777H3.08997",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97498 53.8379V56.2323",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6205 15.2402V17.6329",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6463 18.6445H17.6509",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7331 18.6445H13.7359",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6205 19.8066V22.1993",
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.395,
    y1: 56.605,
    x2: 86.605,
    y2: 56.605,
    stroke: "#005555",
    strokeWidth: 0.79,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitCaseBoxIcon);
export default __webpack_public_path__ + "static/media/Suit_case_Box_Icon.cfe781e0664ecf8ea47cef6dc361e4fa.svg";
export { ForwardRef as ReactComponent };